import styled from 'styled-components'
import { space, width } from 'styled-system'

import { Box } from '@/atoms/layout'

export const FieldWrapper = styled(Box)`
  width: 100%;
  padding: 0 ${({ theme }) => theme.space.S12};
  position: relative;

  &:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.space.S12};
    ${space}
  }

  ${width}
  ${space}

  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 100%;
  }
`
